<template>
	<div v-if="raw">
	<div class="seasonwrapper bg-wrapper" type="Jahreszeiten-Wrapper - Start" objectdata="[object Object]" style="">
	<img src="https://www.amecke.de/files/images/Aktionen/mehr-leben/Blume_oben.png" style="z-index:2;position:absolute;left:0;top:0;width:50%;opacity: 0.8;"/>
	<img src="https://www.amecke.de/files/images/Aktionen/mehr-leben/Blume_unten_.png" style="position:absolute;right:0;bottom:50px;width:30%;"/>
	<a href="https://www.amecke.de/"><img id="headerlogo" src="https://www.amecke.de/files/images/Aktionen/mehr-leben/logo2022.svg" alt="Amecke"></a>

	<div class="content content-header" >

	<div class="ce-text"  style="text-align: center;">
	<div class="ce-headline"><h2>mehr leben!</h2>

	<div class="glow intop " >
	<img src="https://www.amecke.de/files/images/Aktionen/mehr-leben/_glowtop.png" style="left:0" />
	</div>

	<h3>Wer achtsam ist,<br>hat mehr vom Leben.</h3>
		<img src="https://www.amecke.de/files/images/Aktionen/mehr-leben/50pro.png" />
		<h4>für ein sanftes Erlebnis deiner Wahl</h4>
	</div>
	</div>
	<div class="ce-text"  style="text-align: center;position:relative;">
<img src="https://www.amecke.de/files/images/Aktionen/mehr-leben/Element5.png" />
	<img src="https://www.amecke.de/files/images/Aktionen/mehr-leben/Element7.png" />
	<img src="https://www.amecke.de/files/images/Aktionen/mehr-leben/Element9.png" />
	
	
	</div>
	</div>

	<div class="content content-center" style="text-align: left;" >
	<div class="content products">
	
	<!--<img src="https://www.amecke.de/files/images/Aktionen/mehr-leben/SaS_Erdbeer_Apfel_21030634400__DN624223A_1l_Frontal%20Vorne_100dpi_eRGB_220106.png" />
	<img src="https://www.amecke.de/files/images/Aktionen/mehr-leben/SaS_Orange_21030634200_DN601964A_1l_Frontal%20Vorne_100dpi_eRGB_220106.png" />
	<img src="https://www.amecke.de/files/images/Aktionen/mehr-leben/SaS_Apfel_Naturtrueb_21030635600_DN727840A_1l_Frontal%20Vorne_100dpi_eRGB_220106.png" />
	<img src="https://www.amecke.de/files/images/Aktionen/mehr-leben/bluete.svg" />
	<div class="glow" >
	<img src="https://www.amecke.de/files/images/Aktionen/mehr-leben/glowmiddle.png" />
	</div>-->
	<img src="https://www.amecke.de/files/images/Aktionen/mehr-leben/Mitte.png" />
	</div>

		<div class="ce-text content-center-teaser"   style="text-align: center;">
	<div class="ce-headline"><div><h2>Dein Tag war voll und <br>du bist alle?</h2></div>
	</div> 

	<p class="gravitas-medium">Dann gönn dir einen Moment für dich.</p>
			<p class="gravitas-medium">Mit <strong>AMECKE Sanfte Säfte</strong> und einem sanften Erlebnis bei einem unserer <br class="xl-only"><strong>mehr leben</strong> Freizeitpartner.</p>

	</div>
	</div>

	<div class="content content-center" >

	<div class="ce-text"  style=""	>
	<div class="ce-headline"><div><h2>Und so geht‘s</h2></div>
	</div> 
	<ol >
	<li>Kaufe eine Aktionspackung von <strong>AMECKE Sanfte Säfte</strong><br>und schneide den mehr leben Coupon auf der Seite aus.</li>
	<li>Wähle in deiner Region dein sanftes Erlebnis<br>und vereinbare einen Termin.</li>
	<li>Bringe den Coupon zu deinem Erlebnis mit<br>und löse ihn direkt vor Ort ein.</li>
	</ol>
	<p>Je nach Freizeitpartner und bei Online Erlebnissen sind alternative Einlösewege möglich.</p>
	<p>Teilnahme ab 18 Jahren.<br>Unsere Teilnahmebedingungen findest du <a href="https://www.amecke.de/files/images/Aktionen/mehr-leben/teilnahme.pdf" target="_blank">hier</a>.<br>
	<p>Eine Übersicht der teilnehmenden Freizeitpartner und deren Teilnahme und Einlösebedingungen findest du <a @click.prevent="scrollToNode" >hier</a>.</p>
	
	</div>
	 	<div class="content product" style="position:relative;left:60px;" >
	
<img src="https://www.amecke.de/files/images/Aktionen/mehr-leben/Unten.png" />
		<!--<img src="https://www.amecke.de/files/images/Aktionen/mehr-leben/SaS_Orange_21030634200_DN601964A_1l_Frontal%20Vorne_100dpi_eRGB_220106.png"  style="transform: unset;top:0px;max-width:150px; position:relative;"/>
		<img src="https://www.amecke.de/files/images/Aktionen/mehr-leben/Etikett20220902.svg" style="width: 40%;left: -13%;z-index: 1;bottom: 30%;position:absolute"/>-->
	</div>

	</div>
	</div>
	<div class="finder" id="finder">
	
<amecke-partner-container></amecke-partner-container>
	</div>
	</div>

</template>
<script>
	import Base from "./Base.vue";
	import AppContentElement from "./AppContentElement.vue";
	export default {
		extends: Base,
		components: {
			AppContentElement
		},
		data() {
			return {
				vueroutename: this.$route.params.current,
				apicomponentname: "contents"
			};
		},
		updated() {
			// add back-button to content page after first content-element
			let objElems = this.$children;
			// get forst child element
			if (objElems) {
			let firstChildElem = objElems[0].$el;
			this.appendBackButton(firstChildElem);
			}
		},
		mounted() {
					setTimeout(()=>{
			var elements = document.querySelectorAll(".glow");
			if (elements) {
				elements.forEach(element => {
					console.log('glow');
					element.classList.add('glower')

				})}
			},1000)
		},
		created() {
			document.body.classList.add('mehr-leben')
			this.init();
			setTimeout(()=>{
    var script = document.createElement('script');
    script.setAttribute('asyn', 'true');
    script.setAttribute('defer', 'true');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', 'https://amecke.apfelkiste.eu/js/partner.js');
    document.body.appendChild(script);
			},1000)
		},
		methods: {
			appendBackButton(el) {
				// append back-button to contentPage sites
				let elementToAppend = el;
				let elBackButton = "";
				let addBackBtn = true;
				let siteBackBtn = document.querySelector(".site-back-btn");
				// disable back-button for campaign-sites or is startseite or button already exists
				if (
					(this.raw.data && this.raw.data.attributes.isCampaingsite) ||
					this.$route.params.current == "startseite" ||
					(typeof siteBackBtn != "undefined" && siteBackBtn != null)
				) {
					addBackBtn = false;
				}
				if (addBackBtn) {
					elBackButton = document.createElement("div");
					elBackButton.classList.add("screen-wrapper");
					elBackButton.innerHTML ='<div class="site-back-btn"><a onclick="history.back()" class="btn-go-back">Zurück</a><span><span></span><span></span></span></div>';
					elementToAppend.parentNode.insertBefore(
						elBackButton,
						elementToAppend.nextSibling
					);
					// elementToAppend.appendChild(elBackButton);
				}
			},
			   scrollToNode () {

       var element = document.getElementById('finder')
      
      // console.log(element);
      if (element) {
        element.scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        })
      }
    },
			
		},

		watch: {
			$route(to, from) {
				this.objectdata = {};
				// this.raw = {};
				this.init();
			}
		}
	};
</script>

<style lang="scss">
</style>